// extracted by mini-css-extract-plugin
module.exports = {"input":"styles_input__B8LQP","error":"styles_error__6v2ur","attached":"styles_attached__j_Fm3"};